export default {
    install (Vue) {
      // 防止重复点击
      Vue.directive('preventReClick', {
        inserted (el, binding) {
            console.log(el,binding)
          el.addEventListener('click', () => {
            console.log(el.disabled);
            if (!el.disabled) {
              el.disabled = true
              setTimeout(() => {
                el.disabled = false
              },binding.value || 3000)
            }
          })
        }
      })
    }
  }